import { z } from 'zod';
import { CursorQuery } from '../../common/pagination.js';
import { ContentBase, CreatePostInput } from '../../content.js';
import { Paginated } from '../../common/pagination.js';
import { DeleteResult, UpdatePostInput } from '../../content-mutations.js';
import { FeedQuery } from './schemas.js';
export const postsRoutes = {
    pendingGroup: {
        method: 'GET',
        path: '/posts/group/:communityId/pending',
        query: CursorQuery,
        response: Paginated(ContentBase),
    },
    reviewGroup: {
        method: 'POST',
        path: '/posts/group/:communityId/:postId/review',
        body: z.object({ approve: z.boolean() }),
        response: ContentBase,
    },
    create: {
        method: 'POST',
        path: '/posts',
        body: CreatePostInput,
        response: ContentBase,
    },
    feed: {
        method: 'GET',
        path: '/posts',
        query: FeedQuery,
        response: Paginated(ContentBase),
    },
    /** Single item — the post-detail screen and deep links. Blocked-either-way → 404 (AC-GL-18). */
    get: {
        method: 'GET',
        path: '/posts/:postId',
        response: ContentBase,
    },
    /**
     * A member's posts (profile §2.4 item 10, My Post §5.4). The owner also sees
     * their scheduled items (AC-POST-08); everyone else sees published only.
     */
    byAuthor: {
        method: 'GET',
        path: '/users/:userId/posts',
        query: FeedQuery,
        response: Paginated(ContentBase),
    },
    update: {
        method: 'PATCH',
        path: '/posts/:postId',
        body: UpdatePostInput,
        response: ContentBase,
    },
    remove: {
        method: 'DELETE',
        path: '/posts/:postId',
        response: DeleteResult,
    },
};
//# sourceMappingURL=routes.js.map